import {
  DEFAULT_GROUP_WORK_LOCATION,
  GROUP_WORK_LOCATION_OPTIONS,
  formatGroupWorkLocation,
  type GroupWorkLocation,
} from '../../constants/groupWorkLocation';

interface GroupWorkLocationFieldProps {
  value: GroupWorkLocation | string | undefined;
  onChange?: (value: GroupWorkLocation) => void;
  readOnly?: boolean;
}

export default function GroupWorkLocationField({
  value,
  onChange,
  readOnly = false,
}: GroupWorkLocationFieldProps) {
  const selected = (value as GroupWorkLocation) || DEFAULT_GROUP_WORK_LOCATION;

  if (readOnly) {
    return (
      <div>
        <span className="block text-sm font-medium text-gray-700 mb-2">Work Location</span>
        <span className="inline-flex items-center rounded-md bg-indigo-50 px-3 py-2 text-sm font-semibold text-indigo-900 ring-1 ring-inset ring-indigo-200">
          {formatGroupWorkLocation(selected)}
        </span>
      </div>
    );
  }

  return (
    <div>
      <span className="block text-sm font-medium text-gray-700 mb-2">Work Location</span>
      <div
        className="inline-flex rounded-lg border border-gray-300 bg-gray-100 p-1 shadow-sm"
        role="radiogroup"
        aria-label="Work Location"
      >
        {GROUP_WORK_LOCATION_OPTIONS.map((option) => {
          const isSelected = selected === option.value;
          return (
            <button
              key={option.value}
              type="button"
              role="radio"
              aria-checked={isSelected}
              onClick={() => onChange?.(option.value)}
              className={`rounded-md px-4 py-2 text-sm font-semibold transition-all ${
                isSelected
                  ? 'bg-indigo-600 text-white shadow-md ring-2 ring-indigo-600 ring-offset-1'
                  : 'text-gray-600 hover:bg-white hover:text-gray-900'
              }`}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
